import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import {MsalInstance} from './helpers/msalHelper';

import App from './App';
import reportWebVitals from './reportWebVitals';
import IdentityManager from './helpers/identityManager';

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={MsalInstance.getCurrentInstance()}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <IdentityManager />
        <App />
      </MsalAuthenticationTemplate>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
